import { render, staticRenderFns } from "./Administration.vue?vue&type=template&id=fc465638&scoped=true&"
import script from "./Administration.vue?vue&type=script&lang=js&"
export * from "./Administration.vue?vue&type=script&lang=js&"
import style0 from "./Administration.vue?vue&type=style&index=0&id=fc465638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc465638",
  null
  
)

export default component.exports